// extracted by mini-css-extract-plugin
module.exports = {"installCode":"GetStarted-module--installCode--3pcx3","lightInstallCode":"GetStarted-module--lightInstallCode--26Z3P","copyButton":"GetStarted-module--copyButton--vgJmz"};